app.filter('htmlSafe', ($sce) => {
	return (htmlAsText, trustHtml) => {
		return (trustHtml && typeof htmlAsText === 'string') ?
			$sce.trustAsHtml(htmlAsText) :
			htmlAsText;
	};
});
